const TRANSLIT: Record<string, string> = {
  а: "a", б: "b", в: "v", г: "g", д: "d", е: "e", ё: "e",
  ж: "zh", з: "z", и: "i", й: "i", к: "k", л: "l", м: "m",
  н: "n", о: "o", п: "p", р: "r", с: "s", т: "t", у: "u",
  ф: "f", х: "h", ц: "ts", ч: "ch", ш: "sh", щ: "sch",
  ъ: "", ы: "y", ь: "", э: "e", ю: "yu", я: "ya",
};

/**
 * Convert a free-form display label into a backend-safe slug.
 * Cyrillic → ASCII transliteration, lowercased, kebab-cased,
 * stripped of duplicate dashes. Capped at 64 chars (the backend limit
 * on `user_agents.name`). Empty/whitespace-only input falls back to
 * `agent` so a slug always exists.
 */
export function slugify(label: string): string {
  let out = "";
  for (const ch of label.toLowerCase().trim()) {
    if (ch in TRANSLIT) out += TRANSLIT[ch];
    else if (/[a-z0-9]/.test(ch)) out += ch;
    else out += "-";
  }
  out = out.replace(/-+/g, "-").replace(/^-|-$/g, "").slice(0, 64);
  return out || "agent";
}
